import SegmentedControl from "@/components/forms/SegmentedControl";

type UnitSystem = "imperial" | "metric";

const UNIT_OPTIONS = [
  { value: "imperial", label: "ft / lbs" },
  { value: "metric", label: "cm / kg" },
] as const;

interface UnitToggleProps {
  unitSystem: UnitSystem;
  onToggle: (unit: UnitSystem) => void;
}

const UnitToggle = ({ unitSystem, onToggle }: UnitToggleProps) => (
  <SegmentedControl<UnitSystem>
    value={unitSystem}
    onChange={onToggle}
    options={[...UNIT_OPTIONS]}
  />
);

export default UnitToggle;
